import { invoiceActions } from "../../actionTypes";

const initialState = {
	invoiceLocations: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case invoiceActions.FETCH_INVOICE_LOCATIONS: {
			return { ...state, ...initialState };
		}

		case invoiceActions.RESET_INVOICES: {
			return { ...initialState };
		}

		case invoiceActions.FETCH_INVOICE_LOCATIONS_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				invoiceLocations: action.payload,
			};
		}

		case invoiceActions.FETCH_INVOICE_LOCATIONS_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
